
<template>
  <KDiagramView v-if="viewSettings.usesNewKDiagramView" />
  <LegacyKDiagram v-else />
</template>

<script>
import KDiagramView from "./View.vue";
//import LegacyKDiagram from "./LegacyView.vue";
import defaultViewSettings from "@/domain/view_settings/data";

export default {
  name: "KDiagramRouteView",
  components: {
    KDiagramView,
    //LegacyKDiagram,
  },
  data() {
    return {
      viewSettings: defaultViewSettings,
    };
  },
};
</script>
